import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () =>
  ({
    tableViewLoaderCSS: {
      marginLeft: "24px",
      "@media(max-width: 599px)": {
        marginLeft: "0",
        marginTop: "8px"
      },

      "@media(max-width: 839px)": {
        margin: "8px 0"
      }
    },
    tableViewButtonCSS: {
      "@media(max-width: 599px)": {
        marginTop: "2px",
        marginLeft: "0"
      },

      "@media(max-width: 839px)": {
        margin: "8px 0"
      }
    },
    columnsToShowMenuCSS: {
      "& .MuiMenu-paper": {
        maxHeight: "384px",
        minWidth: "330px"
      }
    },
    columnsToShowTitleCSS: {
      borderBottom: `1px solid ${colors.gray300}`,
      padding: "12px 16px"
    },
    columnsToShowOption: {
      position: "sticky",
      bottom: "0",
      background: colors.white,
      zIndex: "1",
      color: colors.blue700,
      borderTop: `1px solid ${colors.gray300}`,
      paddingTop: "13px",

      "&:hover": {
        "&.Mui-disabled": {
          background: colors.white
        }
      },

      "&.Mui-disabled": {
        pointerEvents: "auto"
      }
    }
  }) as CSSObject;
